import gql from "graphql-tag";

export const getClientDocuments = gql `
  query clientDocuments($id: String!, $token: String!) {
    ClientDocuments(id: $id, token: $token) {
      id
      scd_name
      scd_surname
      folders {
        folder_Id
        folder_Name
        documents {
          id
          cdoc_title
          cdoc_desc
          cdoc_path
          cdoc_datecreated
        }
      },
      saved_quotes{
        id,
        description,
        fk_sq_taskguid,
        fk_client_id,
        date_saved
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/ClientDocuments.js